import { notification } from "antd";
import { apiRequest } from "util/services";

/** ReviewsList.createLevelWiseTopics parity */
export function createWelcomeDrawerLevelWiseTopics(topics) {
  if (!Array.isArray(topics) || !topics.length) {
    return [];
  }

  function processChildren(children) {
    return children.map((child) => {
      const processedChild = {
        id: child.id,
        label: child.name,
        children: [],
      };
      if (Object.prototype.hasOwnProperty.call(child, "learning")) {
        processedChild.learning = child.learning;
      }
      if (child.child?.length > 0) {
        processedChild.children = processChildren(child.child);
      }
      return processedChild;
    });
  }

  return topics.map((topic) => {
    const topicStructure = {
      id: topic.id,
      label: topic.name,
      children:
        topic.child?.length > 0 ? processChildren(topic.child) : [],
    };
    if (Object.prototype.hasOwnProperty.call(topic, "learning")) {
      topicStructure.learning = topic.learning;
    }
    return topicStructure;
  });
}

function searchTopicInTree(topicsArr, id) {
  for (const topic of topicsArr || []) {
    if (topic.id === parseInt(id, 10)) {
      return topic;
    }
    if (topic.children?.length) {
      const nested = searchTopicInTree(topic.children, id);
      if (nested) return nested;
    }
    if (topic.child?.length) {
      const nested = searchTopicInTree(topic.child, id);
      if (nested) return nested;
    }
  }
  return null;
}

export function createWelcomeDrawerIsTopicLearningBased(levelWiseTopics) {
  return (id) => {
    const found = searchTopicInTree(levelWiseTopics, id);
    return Boolean(found?.learning);
  };
}

export async function fetchWelcomeDrawerTopicLibrary() {
  const response = await apiRequest(
    "library/all",
    "POST",
    { view: "tree", offset: 0, step: 0 },
    true,
  );
  if (response?.success) {
    const topics = response.success.topics || [];
    return {
      levelWiseTopics: createWelcomeDrawerLevelWiseTopics(topics),
      allTopics: response.success.dropdown_topic_list || [],
    };
  }
  notification.error({
    message: response?.error || "Unable to load topic library",
  });
  return { levelWiseTopics: [], allTopics: [] };
}

export function resolveWelcomeDrawerReviewDashboardId(review) {
  const direct = review?.dash_id ?? review?.dashId ?? review?.dashboard_id;
  if (direct == null || direct === "") return null;
  const parsed = parseInt(direct, 10);
  return Number.isFinite(parsed) ? parsed : null;
}
